var _rect, _rect2;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgCloseXIcon({
  title,
  titleId,
  ...props
}, svgRef) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 23,
    height: 23,
    viewBox: "0 0 23 23",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    x: 16.2634,
    y: 4.94971,
    width: 2,
    height: 16,
    rx: 1,
    transform: "rotate(45 16.2634 4.94971)",
    fill: "#747678"
  })), _rect2 || (_rect2 = /*#__PURE__*/React.createElement("rect", {
    x: 17.6777,
    y: 16.2637,
    width: 2,
    height: 16,
    rx: 1,
    transform: "rotate(135 17.6777 16.2637)",
    fill: "#747678"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgCloseXIcon);
export default __webpack_public_path__ + "static/media/close-x-icon.d74bf49eb7731148835a05a8c43afe00.svg";
export { ForwardRef as ReactComponent };